import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = "http://hdeng2024.cafe24.com/api/controller/admin/manager";

export const adminStratorsApiSlice = createApi({
  reducerPath: "adminStratorsApiSlice",
  baseQuery: fetchBaseQuery({ baseUrl: baseUrl }),
  endpoints: (builder) => ({
    // 관리자 로그인
    getManagerLogin : builder.mutation({
      query : (body : any) => {
        return{
          url : '/getManagerLogin.php', method : 'post', body
        }
      }
    }),
    // 관리자 리스트 가져오기
    getManagerList : builder.mutation({
      query : (param : {page : any, size : number, keyword : string, sortColumn : string, sortOrder : string}) => {
        return{
          url : `/getManagers.php?page=${param.page}&size=${param.size}&keyword=${param.keyword}&sortColumn=${param.sortColumn}&sortOrder=${param.sortOrder}`
        }
      }
    }),
    // 관리자 저장
    setManger : builder.mutation({
      query : (body : any) => {
        return{
          url : '/setManagers.php', method : 'post', body
        }
      }
    }),
    // 관리자 상세보기
    getManagerDetail : builder.mutation({
      query : (param : {idx : any}) => {
        return{
          url : `/getManagerDetails.php?ID=${param.idx}`
        }
      }
    }),
    // 관리자 수정
    updManager : builder.mutation({
      query : ( body : any ) => {
        return{
          url : '/updManagers.php', method : 'post', body
        }
      }
    }),
    // 관리자 정보 호출
    getAdminInfo : builder.mutation({
      query : (param : {id : string}) => {
        return{
          url : `/getAdminInfo.php?manager_uuid=${param.id}`
        }
      }
    })
  }),
});

export const {
  useGetManagerLoginMutation, useGetManagerListMutation, useSetMangerMutation, useGetManagerDetailMutation, useUpdManagerMutation, useGetAdminInfoMutation
} = adminStratorsApiSlice;